/* loaded by smart-asset */
export default require("./play-button~KMZeLnuO.png")